import { render, staticRenderFns } from "./ReportQuotationTable.vue?vue&type=template&id=11856743&scoped=true&lang=html"
import script from "./ReportQuotationTable.vue?vue&type=script&lang=js"
export * from "./ReportQuotationTable.vue?vue&type=script&lang=js"
import style0 from "./ReportQuotationTable.vue?vue&type=style&index=0&id=11856743&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11856743",
  null
  
)

export default component.exports